import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
})
export class ToggleSwitchComponent implements OnInit {

  @Input() withConfirm = true;
  @Input() id = 0;
  @Input() selected = false;
  @Input() color = 'blue';
  @Input() channel = new EventEmitter<boolean>();
  @Input() confirmChannel = new EventEmitter<any>();
  @Output() confirm = new EventEmitter<boolean>();
  @Output() onClick = new EventEmitter<boolean>();
  @Input() confirmMessage: string;
  @Input() disabled = false;

  constructor() {
  }

  ngOnInit() {
  }

  prevent($event) {
    $event.stopPropagation();
    $event.preventDefault();
  }

  onChange() {
    this.channel.emit(!this.selected);
    this.confirm.emit(!this.selected);
  }
}
